import { Component } from "react";
import { connect } from "react-redux";
import DataTable from "components/DigiHapi/DataTable";
import { bindActionCreators } from "redux";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// DigiHapi components
import SnackBarContainer from "components/DigiHapi/SnackBarContainer";
import MDWizard from "components/DigiHapi/MDWizard";

import { GrOrganization } from "react-icons/gr";

import {
	fetchGetOrganizationDetails,
	fetchGetOrganizationsNames,
	fetchDeleteOrganization,
	fetchAddOrganization,
	fetchUpdateOrganization
} from "actions/organization";
import { fetchGetCommunityDetails } from "actions/community";
import {
	RESET_ORGANIZATION,
	SET_ORGANIZATIONS_NAME_FILTER,
	SET_ORGANIZATIONS_SORTED,
	SET_DELETE_ORGANIZATION_CONFIRMATION_NAME
} from "actions/types";

import DeleteConfirmationDialog from "components/DigiHapi/DeleteConfirmationDialog";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";

const { REACT_APP_DEEPLINK_URL = "https://app.hapicolibri.digihapi.com" } =
	process.env;

class OrganizationsWizard extends Component {
	fetchAddOrganization = () => {
		const {
			fetchAddOrganization,
			name,
			stars,
			customUri,
			address,
			zipCode,
			city,
			webSiteUrl,
			mail,
			loc,
			phone,
			fax,
			registerkey,
			files,
			channels,
			isVisible
		} = this.props;

		fetchAddOrganization({
			name,
			customUri,
			stars,
			address,
			zipCode,
			city,
			webSiteUrl,
			mail,
			loc,
			phone,
			fax,
			registerkey,
			files,
			channelsIds: Object.values(channels),
			isVisible
		});
	};

	fetchUpdateOrganization = () => {
		const {
			fetchUpdateOrganization,
			_id,
			name,
			customUri,
			stars,
			registerkey,
			address,
			zipCode,
			city,
			webSiteUrl,
			mail,
			loc,
			phone,
			fax,
			files,
			logoUri,
			mapUri,
			mapSmallUri,
			equipmentsIds,
			channels,
			isVisible
		} = this.props;

		fetchUpdateOrganization({
			_id,
			name,
			customUri,
			stars,
			registerkey,
			address,
			zipCode,
			city,
			webSiteUrl,
			mail,
			loc,
			phone,
			fax,
			files,
			logoUri,
			mapUri,
			mapSmallUri,
			equipmentsIds,
			channelsIds: Object.values(channels),
			isVisible
		});
	};

	render() {
		const { update, isFetching, onClose } = this.props;
		return (
			<Grid item xs={12}>
				<MDWizard
					onClose={onClose}
					isFetching={isFetching}
					validate
					steps={[
						{
							stepName: "Illustration",
							stepComponent: Step1,
							stepId: "picture"
						},
						{
							stepName: "Informations",
							stepComponent: Step2,
							stepId: "infos"
						},
						{
							stepName: "Localisation",
							stepComponent: Step3,
							stepId: "localisation"
						}
					]}
					title={
						update
							? "Mise à jour d'une organisation"
							: "Ajout d'une organisation"
					}
					finishButtonClick={
						update ? this.fetchUpdateOrganization : this.fetchAddOrganization
					}
				/>
			</Grid>
		);
	}
}

class OrganizationsPage extends Component {
	state = {
		wizard: null,
		organizationToDelete: null,
		name: ""
	};

	componentDidMount() {
		this.props.fetchGetOrganizationsNames();
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			fetchGetOrganizationsNames,
			snackInfoMsg,
			newWizard,
			page,
			limit,
			sorted,
			nameFilter
		} = this.props;

		if (snackInfoMsg && prevProps.snackInfoMsg !== snackInfoMsg) {
			this.setState({
				wizard: null
			});
			fetchGetOrganizationsNames(page, limit, sorted, nameFilter);
		}

		if (newWizard && prevProps.newWizard !== newWizard) {
			this.addWizard(newWizard === "update");
		}
	}

	onClose = () => {
		this.setState({
			wizard: null
		});
		this.props.dispatch({
			type: RESET_ORGANIZATION
		});
	};

	addWizard = (update = true) => {
		this.setState({
			wizard: (
				<ConnectedOrganizationsWizard update={update} onClose={this.onClose} />
			)
		});
	};

	changeCommunity = id => {
		this.props.fetchGetCommunityDetails(id);
	};

	editOrganization = id => {
		this.props.fetchGetOrganizationDetails(id);
	};

	deleteOrganization = id => {
		this.props.fetchDeleteOrganization(id, this.props.deleteConfirmationName);
	};

	getRoundButtons = (id, name, customUri) => {
		return [
			{
				color: "success",
				icon: "where_to_vote",
				onClick: this.changeCommunity
			},
			...(customUri
				? [
						{
							color: "warning",
							icon: "mobile_screen_share",
							href: `${REACT_APP_DEEPLINK_URL}/${customUri}/actualites`,
							target: "_blank",
							tooltip: "Ouvrir sur mobile"
						}
				  ]
				: []),
			{ color: "info", icon: "edit", onClick: this.editOrganization },
			{ color: "error", icon: "delete", onClick: this.delete }
		].map(({ color, icon, onClick, tooltip, ...props }) => (
			<Tooltip key={icon} title={tooltip || ""} placement="bottom">
				<span>
					<MDButton
						variant="gradient"
						color={color}
						size="small"
						iconOnly
						circular
						disabled={!!this.state.wizard}
						onClick={() => onClick?.(id, name)}
						sx={{ mx: 0.25 }}
						{...props}
					>
						<Icon>{icon}</Icon>
					</MDButton>
				</span>
			</Tooltip>
		));
	};

	getOrganizations = () => {
		const { organizationsNames } = this.props;

		const organizationsObj = Object.values(organizationsNames).map(
			({ _id, name, customUri }) => {
				return {
					name,
					actions: (
						<MDBox display="flex" justifyContent="flex-end">
							{this.getRoundButtons(_id, name, customUri)}
						</MDBox>
					)
				};
			}
		);
		return organizationsObj;
	};

	delete = (communityId, organizationName) => {
		this.setState({
			organizationToDelete: { id: communityId, name: organizationName }
		});
	};

	render() {
		const { organizationToDelete } = this.state;
		const {
			isFetchingList,
			dispatch,
			page,
			totalPages,
			limit,
			sorted,
			fetchGetOrganizationsNames,
			nameFilter,
			snackInfoMsg,
			snackErrorMsg
		} = this.props;

		return (
			<SnackBarContainer
				snackInfoMsg={snackInfoMsg}
				snackErrorMsg={snackErrorMsg}
			>
				<Grid container spacing={3} justifyContent="center">
					<Grid item xs={12}>
						<Card>
							<MDBox
								mx={2}
								mt={-3}
								py={2}
								px={2}
								variant="gradient"
								bgColor="primary"
								borderRadius="lg"
								coloredShadow="primary"
								display="flex"
								alignItems="center"
								color="white"
							>
								<GrOrganization size={24} />
								<MDTypography variant="h6" color="white" ml={1.5}>
									Organisations
								</MDTypography>
							</MDBox>
							<MDBox p={2}>
								<DataTable
									data={this.getOrganizations()}
									filterable
									columns={[
										{
											Header: "Nom",
											accessor: "name",
											sortable: true,
											filterable: true
										},
										{
											Header: "Actions",
											accessor: "actions",
											sortable: false,
											filterable: false
										}
									]}
									showPaginationTop
									showPaginationBottom={false}
									manual
									manualFilters
									onFetchData={state => {
										if (
											page !== state.page + 1 ||
											limit !== state.pageSize ||
											sorted !== state.sorted ||
											nameFilter !== state.filtered?.[0]?.value
										) {
											dispatch({
												type: SET_ORGANIZATIONS_SORTED,
												value: state.sorted
											});
											dispatch({
												type: SET_ORGANIZATIONS_NAME_FILTER,
												value: state.filtered?.[0]?.value
											});
											fetchGetOrganizationsNames(
												state.page + 1,
												state.pageSize,
												state.sorted,
												state.filtered?.[0]?.value
											);
										}
									}}
									loading={isFetchingList}
									defaultPageSize={limit}
									defaultSorted={sorted}
									page={page - 1}
									pageSizeOptions={[5, 10, 15, 20, 40, 80]}
									pages={totalPages}
									previousText="Précédent"
									nextText="Suivant"
									rowsText="Lignes"
									noDataText="Aucunes organisations"
									ofText="sur"
									loadingText="Chargement..."
								/>
							</MDBox>
							<MDBox p={2} display="flex" justifyContent="flex-end" gap={1}>
								<MDButton
									variant="gradient"
									color="primary"
									onClick={() => this.addWizard(false)}
									disabled={Boolean(this.state.wizard)}
								>
									<Icon>add</Icon>
									&nbsp;{"Ajout d'une organisation"}
								</MDButton>
							</MDBox>
						</Card>
					</Grid>
					{this.state.wizard}
				</Grid>
				<DeleteConfirmationDialog
					open={!!organizationToDelete}
					message="Êtes-vous sûr de vouloir supprimer l'organisation ?"
					instruction={`Confirmer la suppression de l'organisation en saisisant le nom de l'organisation ${organizationToDelete?.name}`}
					inputLabel="Organisation ..."
					inputId="organization"
					onInputChange={e =>
						dispatch({
							type: SET_DELETE_ORGANIZATION_CONFIRMATION_NAME,
							value: e.target.value
						})
					}
					onCancel={() => this.setState({ organizationToDelete: null })}
					onConfirm={() => {
						this.deleteOrganization(organizationToDelete.id);
						this.setState({ organizationToDelete: null });
					}}
				/>
			</SnackBarContainer>
		);
	}
}

const mapStateToProps = state => {
	const {
		_id,
		isFetching,
		isFetchingList,
		name,
		address,
		zipCode,
		city,
		webSiteUrl,
		mail,
		loc,
		phone,
		fax,
		registerkey,
		files,
		snackInfoMsg,
		snackErrorMsg,
		logoUri,
		mapUri,
		mapSmallUri,
		newWizard,
		equipmentsIds,
		deleteConfirmationName,
		channels,
		citiesTags,
		customUri,
		organizationsNames,
		page,
		hasNextPage,
		nextPage,
		totalPages,
		totalDocs,
		limit,
		sorted,
		nameFilter,
		stars,
		isVisible
	} = state.organizationReducer;

	return {
		_id,
		isFetching,
		isFetchingList,
		name,
		address,
		zipCode,
		city,
		webSiteUrl,
		mail,
		loc,
		phone,
		fax,
		registerkey,
		files,
		snackInfoMsg,
		snackErrorMsg,
		logoUri,
		mapUri,
		mapSmallUri,
		newWizard,
		equipmentsIds,
		deleteConfirmationName,
		channels,
		citiesTags,
		customUri,
		organizationsNames,
		page,
		hasNextPage,
		nextPage,
		totalPages,
		totalDocs,
		limit,
		sorted,
		nameFilter,
		stars,
		isVisible
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetOrganizationsNames,
			fetchGetOrganizationDetails,
			fetchDeleteOrganization,
			fetchAddOrganization,
			fetchUpdateOrganization,
			fetchGetCommunityDetails
		},
		dispatch
	);
	return { ...actions, dispatch };
};

const ConnectedOrganizationsWizard = connect(
	mapStateToProps,
	mapDispatchToProps
)(OrganizationsWizard);

export default {
	OrganizationsPage: connect(
		mapStateToProps,
		mapDispatchToProps
	)(OrganizationsPage),
	OrganizationsWizard: ConnectedOrganizationsWizard
};
